module.exports = __webpack_public_path__ + "img/cargo_parked.7ad3d9a5.svg";